export default "__VITE_ASSET__Ba2q_X2u__"